import React, { useRef } from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';

import { paths } from 'config/path_helpers';

import { SchoolProfileCategory } from '@schools/app/types';
import profileGroups from '@schools/app/utilities/profile_groups';

import colors from '@magoosh/lib/styles/colors.module.scss';
import style from './style.module.scss';

interface Props {
  category: SchoolProfileCategory;
  className?: string;
  preview: boolean;
}

const CategoryProfileList: React.FC<Props> = (props) => {
  const isLoaded = !!props.category;

  return (
    <div className={props.className}>
      <div className="container">
        <div className={cx(style.categoryGroups, 'd-flex flex-wrap')}>
          {
            profileGroups(props.category).map((group, idx) => (
              <div key={idx} className={style.categoryGroup}>
                <h3 className="u-margin-A-n u-margin-B-xs">{group.name}</h3>

                {
                  group.profiles.map((profile, profileIdx) => (
                    <div key={profileIdx} className="u-padding-V-xxs" style={{ borderBottom: `1px solid ${colors.grayLightest}` }}>
                      <Link
                        className="small text-no-decoration text-gray-light"
                        to={paths.admissions.schoolProfile(profile.slug, props.category.slug, props.preview)}
                      >
                        <strong>{profile.name}</strong>
                      </Link>
                    </div>
                  ))
                }
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
};

export default CategoryProfileList;
